// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  idleTimeInMinutes: 5,

  //  navigation : 'http://localhost:49678/#/',
   navigation : 'https://ng.afstest.com/vendorportalUI/#/',

  BaseApiUrl: 'https://ng.afstest.com/apiCustomerPortal/api',
  // BaseApiUrl : 'https://ng.afstest.com/apiVendorPortal/api',
  // BaseApiUrl:   'https://opsxpanse.afstest.com/apiVendorPortal/api',
  //BaseApiUrl: 'https://opsxpanse.afstest.com/apiCustomerPortal/api',

  //staging
  getBaseUrl() {
    return 'https://ng.afstest.com/apicustomerportal/api';
    //return 'https://opsxpanse.afstest.com/apiCustomerPortal/api'
  }

};



